import React from "react";
import TrelloTodo from "../components/TrelloTodo";

const Home = () => {
  return <TrelloTodo />;
};

export default Home;
